import React, { Component } from 'react';
import RiskAssessmentMenu from './menu/RiskAssessmentMenu';
import { Route, Switch } from 'react-router-dom';
import { redirectTo } from '../../../routing/redirectService';
import EventListContainer from './util/EventListContainer';
import {
    reverseRuleCategoryUrl,
    RuleCategory
} from '../../../services/RuleCategory';
import TransparentButton from '../../../shared/button/transparent-button/TransparentButton';
import { PageTitleHeader } from '../../../shared/headers/PageTitleHeader';
import { PageActionsRow } from '../../../shared/headers/PageActionsRow';

class RiskAssessmentContainer extends Component {
    componentDidMount() {
        // todo [mandy]: future improvement ... load subsection that was chosen last.
        if (this.props.location.pathname === '/risk-assessment') {
            redirectTo('/risk-assessment/anti-money-laundering');
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.location.pathname === '/risk-assessment') {
            redirectTo('/risk-assessment/anti-money-laundering');
        }
    }

    onClickModifyWeights = () => {
        // todo [mandy] fix this code so as not to make use of the url. Pass prop to component instead.
        // let ruleCategoryUrl = getRuleCategoryUrl(this.props.ruleCategory);
        let ruleCategoryUrl = this.props.location.pathname.replace(
            '/risk-assessment/',
            ''
        );
        // redirectTo('/modify-weights/' + ruleCategoryUrl, {ruleCategory: this.props.ruleCategory});
        redirectTo('/modify-weights/' + ruleCategoryUrl, {
            ruleCategory: reverseRuleCategoryUrl(ruleCategoryUrl)
        });
    };

    render() {
        return (
            <span className="container">
                <PageActionsRow leftContent={<RiskAssessmentMenu />}>
                    <TransparentButton
                        onClick={this.onClickModifyWeights.bind(this)}
                    >
                        <i className={'material-icons'}>tune</i>
                        Modify Weights
                    </TransparentButton>
                </PageActionsRow>

                {/*todo fix the below () => <Component/>*/}
                {/*todo check render vs component*/}
                <Switch>
                    <Route
                        exact
                        path="/risk-assessment/anti-money-laundering"
                        component={() => (
                            <EventListContainer
                                ruleCategory={
                                    RuleCategory.ANTI_MONEY_LAUNDERING
                                }
                            />
                        )}
                        title={() => (
                            <PageTitleHeader
                                title={'Alerts'}
                                subtitle={'Dismiss Alert'}
                            />
                        )}
                    />
                    <Route
                        exact
                        path="/risk-assessment/fraud"
                        component={() => (
                            <EventListContainer
                                ruleCategory={RuleCategory.FRAUD}
                            />
                        )}
                        title={() => (
                            <PageTitleHeader
                                title={'Alerts'}
                                subtitle={'Dismiss Alert'}
                            />
                        )}
                    />
                    <Route
                        exact
                        path="/risk-assessment/responsible-gambling"
                        component={() => (
                            <EventListContainer
                                ruleCategory={RuleCategory.RESPONSIBLE_GAMBLING}
                            />
                        )}
                        title={() => (
                            <PageTitleHeader
                                title={'Alerts'}
                                subtitle={'Dismiss Alert'}
                            />
                        )}
                    />
                </Switch>
            </span>
        );
    }
}

export default RiskAssessmentContainer;
